<template>
  <div class="bg-nosotros2">
    <el-row :gutter="20" class="title-nosotros">
      <el-col :md="24" :xs="24" data-aos="fade-right">
        <h1 class="titulo_nos">{{ $t('nosotros.titulo') }}</h1>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="24" :xs="24" data-aos="fade-right">
        <div>
          <div class="mision_new" v-html="$t('nosotros.intro')"></div>

          <div class="mision_new" v-html="$t('nosotros.intro1')"></div>

          <div class="mision_new" v-html="$t('nosotros.intro2')"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  mounted() {
    AOS.init({
      duration: 1000, // velocidad de la animación (ms)
      offset: 100, // distancia antes de activar
      once: false, // si lo ponés en true solo se anima 1 vez
    })
  },
}
</script>
<style>
.bg-nosotros2 {
  background-color: #d35915;
  position: relative;
  z-index: 999;
  padding: 5% 10% 5% 10%;
}
.titulo_nos {
  padding: 0px;
  margin: 0px;
  float: left;
  /* font-size: 2.3rem; */
  font-size: 62px;
  color: white;
  font-family: 'roboto-black';
  margin-bottom: 2.5%;
}
.mision_new {
  margin: 15px auto;
  color: #fff;
  line-height: 1.3;
  /* font-size: 0.9rem; */
  font-size: 23px;
  font-family: 'roboto-regular';
  text-align: justify;
  hyphens: auto;
}
@media (min-width: 2561px) {
  .titulo_nos {
    font-size: 65px;
  }
  .mision_new {
    font-size: 31px;
    padding: 0px 0px 20px 5%;
  }
  .title-nosotros {
    padding: 0px 0px 20px 5%;
  }
  .bg-nosotros2 {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 7% 10% 7% 10%;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .titulo_nos {
    font-size: 62px;
  }
  .mision_new {
    font-size: 25px;
    /* padding: 0px 0px 0px 5%; */
  }
  .title-nosotros {
    /* padding: 0px 0px 20px 5%; */
  }
  .bg-nosotros2 {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 7% 10% 7% 10%;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .titulo_nos {
    font-size: 56px;
  }
  .mision_new {
    font-size: 23px;
    /* padding: 0px 0px 20px 5%; */
  }

  .bg-nosotros2 {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 7% 10% 7% 10%;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .titulo_nos {
    font-size: 50px;
  }
  .mision_new {
    font-size: 21px;
    /* padding: 0px 0px 5px 5%; */
  }

  .bg-nosotros2 {
    padding: 7% 11% 7% 10.5%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .titulo_nos {
    font-size: 51px;
  }
  .mision_new {
    font-size: 18px;
    /* padding: 0px 0px 10px 7%; */
  }
  .bg-nosotros2 {
    padding: 7% 10% 7% 10%;
  }
  /* .title-nosotros {
    padding: 0px 0px 20px 7%;
  } */
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .titulo_nos {
    font-size: 35px;
  }
  .mision_new {
    font-size: 19px;
    text-align: left;
    /* padding: 0px 0px 15px 5%; */
  }

  .bg-nosotros2 {
    padding: 12% 10% 12% 10%;
  }
}
@media (max-width: 374px) {
  .titulo_nos {
    font-size: 35px;
  }
  .mision_new {
    font-size: 19px;
  }

  .bg-nosotros2 {
    padding: 12% 10% 12% 10%;
  }
}
@media (max-width: 360px) {
  .titulo_nos {
    font-size: 35px;
  }
  .mision_new {
    font-size: 18px;
    text-align: left;
    /* padding: 0px 0px 15px 5%; */
  }

  .bg-nosotros2 {
    padding: 12% 10% 12% 10%;
  }
}
</style>
